import loginController from '../../_api/controllers/login.js'

const state = null

const prevMonth = () => {
  let date = new Date()
  var thisMonth = date.getMonth()
  date.setMonth(thisMonth - 1)
  if (date.getMonth() !== thisMonth - 1 && (date.getMonth() !== 11 || (thisMonth === 11 && date.getDate() === 1))) date.setDate(0)
  return date
}

const actions = {
  login ({commit}, User) {
    return new Promise((resolve, reject) => {
      loginController.Login(User.login, User.password).then((response) => {
        if ((!response.error)) {
          commit('setUser', response)
          resolve(response)
        }
      }).catch((response) => {
        reject(response)
      })
    })
  },
  logout ({commit}) {
    commit('logout', {})
  }
}

const mutations = {
  initializeStore (state) {
    // Check if the ID exists
    if (localStorage.getItem('user')) {
      let user = JSON.parse(localStorage.getItem('user'))
      let date = prevMonth()
      user.anoCompetencia = date.getFullYear()
      user.mesCompetencia = date.getMonth() + 1
      Object.assign(state, user)
    }
  },
  setUser (state, user) {
    let date = prevMonth()
    user.anoCompetencia = date.getFullYear()
    user.mesCompetencia = date.getMonth() + 1
    Object.assign(state, user)
  },
  logout (state) {
    Object.assign(state, null)
  }
}

const getters = {
  isAuth: state => !!state.codigo || false,
  userName: state => state.nome,
  menus: state => state.telas ? state.telas.filter(x => !!x.status && !!x.menu) : [],
  dashboard: state => !!state.telas && !!state.telas.find(x => x.nome === 'dashboards' && x.status === true),
  dashboardAssessor: state => !!state.telas && !!state.telas.find(p => p.path === '/dashboardassessor' && p.nome === 'dashboardassessor' && p.status === true),
  dashboardMetasAssessor: state => !!state.telas && !!state.telas.find(p => p.path === '/dashboardmetasassessor' && p.nome === 'dashboardmetasassessor' && p.status === true),
  user: state => state,
  isGestor: state => state.tipoGrupoUsuarioId === 2 || false,
  anoCompetencia: state => state.anoCompetencia || null,
  mesCompetencia: state => state.mesCompetencia || null
}

export const auth = {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.module.js